import { useCallback, useEffect, useState } from 'react'
import { CurrencyModalProps } from './CurrencyModal.types'

/** Holds the pending pick until it is confirmed, mirroring the main site's modal. */
export function useCurrencyModalController({ code, onClose, onConfirm }: CurrencyModalProps) {
  const [selected, setSelected] = useState(code)

  const onSelect = useCallback((nextCode: string) => setSelected(nextCode), [])

  const onConfirmClick = useCallback(() => {
    onConfirm(selected)
    onClose()
  }, [onConfirm, onClose, selected])

  // Discard the unsaved draft and restore the active currency on cancel/dismiss.
  const onCancel = useCallback(() => {
    setSelected(code)
    onClose()
  }, [code, onClose])

  useEffect(() => {
    setSelected(code)
  }, [code])

  return { selected, onSelect, onConfirmClick, onCancel }
}
